<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-8 shadow-lg items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
         <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="formData._id" class="text-xl font-semibold text-blue-700">
            Update Order
          </div>
          <div v-else class="text-xl font-semibold text-blue-500">
            New Order
          </div>
        </div>
      </div>
      <!-- ********************************************************Customer information **********************************-->

      <div class="px-6 mt-3">
        <div class="flex w-full space-x-2">
          <div
            class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg"
          >
            <div class="flex w-full">
              <span class="rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-blue-400">person</i>
              </span>

              <div class="ml-5 w-full">
                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                  Customer information
                </div>
                <div class="text-sm font-light text-gray-500"></div>
                <div class="w-full space-y-4">
                  <div class="flex">
                    <div
                      class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                    >
                      <div
                        class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                      >
                        <p>
                          <label
                            for="customerFullName"
                            class="bg-white text-gray-700 px-1"
                            >Full name
                            <span :class="$colors.required">*</span></label
                          >
                        </p>
                      </div>
                      <p>
                        <input
                          id="customerFullName"
                          autocomplete="false"
                          tabindex="0"
                          type="text"
                          v-model="formData.customer.fullName"
                          class="py-2 text-xs px-2 outline-none block h-full w-full"
                        />
                      </p>
                    </div>
                  </div>

                  <div
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="customerPhone"
                          class="bg-white text-gray-700 px-1"
                          >Phone <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <input
                        id="customerPhone"
                        autocomplete="false"
                        tabindex="0"
                        type="text" placeholder="phone ..."
                        v-model="formData.customer.phone"
                        class="py-2 text-xs px-2 border mb-2 outline-none block h-full w-full"
                      />
                    </p>
                    <p class="Note"><strong>Note</strong>: Pour utiliser plusieurs numéros, vous pouvez les séparer avec | . <strong>Exemple</strong>: (0708852502<strong>|</strong>0708852501)</p>
                  </div>
                
                  <div
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="customerAddress"
                          class="bg-white text-gray-700 px-1"
                          >Address
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <textarea
                        id="customerAddress"
                        autocomplete="false"
                        tabindex="0"
                        type="text"
                        v-model="formData.customer.address"
                        class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"
                      ></textarea>
                    </p>
                  </div>

                  <div
                    v-if="currentUser.type == 'Admin' || currentUser.type == 'Administrateur'"
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="customerShippingAddress"
                          class="bg-white text-gray-700 px-1"
                          >Shipping address
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <textarea
                        id="customerShippingAddress"
                        autocomplete="false"
                        tabindex="0"
                        type="text"
                        v-model="formData.customer.shippingAddress"
                        class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"
                      ></textarea>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ****************************** Order Information *********************************************-->

          <div class="w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
            <div class="flex w-full mb-5">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">home</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                       Warehouse
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full">
                        <div class="flex justify-center items-center">
                          <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current mr-2"><path  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"></path></svg>
                          <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">Country (warehouse)
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select :disabled="currentUser && currentUser.warehouses && currentUser.warehouses.length==1?true:false||formData._id?true:false" @input="setSelectedW" v-model="formData.warehouse" :options="warehouses" label="name">
                               <template slot="option" slot-scope="option">
                                <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                                {{ $f.getCountryNameByCode(options,option.country)}} 
                                </template>
                          </v-select>
                          </p>
                        </div>
                        </div>
                     
                        <span v-if="checkWarehousingParent.length>0 && currentUser.type != 'Seller'" class="ware_prin">
                         
                          <div  class="border mll-4 hover:border-blue-400  w-10/12 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">Zone (City)
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select :disabled="formData._id?true:false" @input="setSelectedWParent" v-model="formData.warehouseParent" :options="checkWarehousingParent" label="name"></v-select>
                          </p>
                        </div>
                        </span >
                       
                        
                        

                      </div>
                    </div>
             </div>
            <div class="flex w-full mt-2">
              <span class="rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-blue-400"
                  >local_grocery_store</i
                >
              </span>

              <div class="ml-5 w-full">
                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                  Order information
                </div>
                <div class="text-sm font-light text-gray-500"></div>
                <div class="w-full space-y-4">
                  <div class="flex">
                    <div
                      class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                    >
                      <div
                        class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                      >
                        <p>
                          <label
                            for="source"
                            class="bg-white text-gray-700 px-1"
                            >Order source
                           </label
                          >
                        </p>
                      </div>
                      <p>
                        <input
                          id="source"
                          autocomplete="false"
                          tabindex="0"
                          type="text"
                          v-model="formData.source"
                          class="py-2 text-xs px-2 outline-none block h-full w-full"
                        />
                      </p>
                    </div>
                  </div>

                  <div
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="sourceLink"
                          class="bg-white text-gray-700 px-1"
                          >Order source link
                         </label
                        >
                      </p>
                    </div>
                    <p>
                      <input
                        id="sourceLink"
                        autocomplete="false"
                        tabindex="0"
                        type="text"
                        v-model="formData.sourceLink"
                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                      />
                    </p>
                  </div>

                  <!-- <div
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="date" class="bg-white text-gray-700 px-1"
                          >Order date
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                       <datetime-v2 v-model="formData.date"
                                       placeholder="Order date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                    </p>
                  </div> -->
                   <div v-if="currentUser.type != 'Seller'"
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="date" class="bg-white text-gray-700 px-1"
                          >Shipping date
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                       <datetime-v2  v-model="formData.shippingdate"
                                       placeholder="Shipping date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                    </p>
                  </div>
                <!--  <div
                    v-if="currentUser.type == 'Admin' || currentUser.type == 'Administrateur'"
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="date" class="bg-white text-gray-700 px-1"
                          >Price Total
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <input
                        autocomplete="false"
                        tabindex="0"
                        type="text"
                        v-model="formData.totalPrice"
                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                      />
                    </p>
                  </div> -->
                  <!-- <div
                    v-if="currentUser.type == 'Admin' || currentUser.type == 'Administrateur'"
                    class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="seller" class="bg-white text-gray-700 px-1"
                          >Seller
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <select
                        id="type"
                        name="seller"
                        autocomplete="type"
                        v-model="formData.seller"
                        @change="changeSeller"
                        class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                      >
                        <option selected disabled :value="null">Seller</option>
                        <option
                          v-for="seller in sellers"
                          :key="seller._id"
                          :value="seller"
                        >
                          {{ seller.email }}
                        </option>
                      </select>
                    </p>
                  </div> -->
                 
                 
                   <div v-if="currentUser &&  currentUser.type && currentUser.type != 'Seller'" class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="seller" class="bg-white text-gray-700 px-1"> Seller
                        <span :class="$colors.required">*</span></label>
                      </p>
                    </div>    
                    <p>
                        <v-select label="fullName" :disabled="formData && formData._id?true:false" @search="getUsersDebance($event,'shipsen')" @input="changeSeller" v-model="formData.seller" :options="sellers"></v-select>
                    </p>         
                 </div>  
                
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ********************************************************Product Table assigned to order **********************************-->

        <div class="flex w-full">
          <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg">
            <div class="flex w-full justify-between items-center h-auto p-6">
              <div class="flex w-full">
                <span class="rounded-full h-12 w-12 bg-gray-200">
                  <i class="material-icons p-3 text-blue-500">local_mall</i>
                </span>
                <div class="ml-3 w-full p-2 pb-8">
                  <div
                    class="w-full flex text-base font-semibold text-gray-600"
                  >
                    <p class="w-1/2">Products</p>
                    <div class="w-full">
                      <button
                        @click="OpenPopUp"
                        class="flex text-white mx-auto max-w-sm rounded-md text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
                        :disabled="isDisabled"
                      >
                        Select Product
                      </button>
                    </div>
                  </div>

                  <div class="mt-4 overflow-x-auto">
                    <table
                      v-if="formData.details"
                      class="min-w-full leading-normal"
                    >
                      <thead>
                        <tr>
                           <th
                            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                          >
                            Image
                          </th>
                          <th
                            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                          >
                            Name
                          </th>


                          <th
                            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                          >
                            Quantity
                          </th>
                          <th
                            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                          >
                            Unit Price
                          </th>

                          <th
                            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                          >
                           Total
                          </th>

                          <th
                            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(item, index) in formData.details"
                        :key="index"
                      >
                        <tr>
                          <td class="w-10 px-6 py-2 whitespace-no-wrap border-b border-gray-200"><div class="flex"><div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden"><img :alt="item.name" :src="item.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"></div></div></td>
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b border-gray-200"
                          >
                            <div
                              class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                            >
                              {{ item.product.name }}
                            </div>
                          </td>

                          <!-- <td
                            class="px-6 py-2 whitespace-no-wrap border-b border-gray-200"
                          >
                            <div
                              class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                            >
                              {{ item.product.price }} XOF
                            </div>
                          </td> -->

                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b border-gray-200"
                          >
                            <div class="flex space-x-6">
                              <button
                                :class="$colors.textPrimary"
                                class="bg-blue-500 rounded-md w-6 h-6 flex items-center focus:outline-none"
                                @click="addQuantity(index)"
                              >
                                <span class="font-bold text-2xl text-white">
                                  <i class="material-icons mt-2">add</i>
                                </span>
                              </button>
                              <span
                                :class="$colors.textPrimary"
                                class="text-gray-700 text-sm h-6 flex items-center focus:outline-none"
                              >
                                <input
                                  class="focus:outline-none w-12 text-center"
                                  type="text"
                                  v-model="item.quantity"
                                />
                              </span>

                              <button
                                :class="$colors.textPrimary"
                    
                                @click="removeQuantity(index)"
                                class="bg-blue-500 rounded-md w-6 h-6 text-white flex items-center focus:outline-none"
                              >
                                <span
                                  class="font-bold text-2xl text-white mt-1"
                                >
                                  <i class="material-icons">remove</i>
                                </span>
                              </button>
                            </div>
                            <div
                              class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                            ></div>
                          </td>
                          <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                            <div>
                              <input autocomplete="false" tabindex="0" min="0" type="number" v-model="item.unitPrice" class="border border-blue-600 py-2 text-xs px-2 outline-none block h-full w-full"
                      />
                            </div>
                          </td>
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b border-gray-200"
                          >
                            <div
                              class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                            >
                              {{ item.unitPrice * item.quantity }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup>
                            </div>
                          </td>

                          <td
                            class="py-4 whitespace-no-wrap border-b border-gray-200"
                          >
                            <div class="flex justify-center">
                              <button
                                @click="removeProduct(item, index)"
                                :disabled="formData.status && formData.status.name && formData.status.name=='Confirmed'?true:false"
                                :class="$colors.actionTable"
                                class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1"
                              >
                                <i class="material-icons mx-1">delete</i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                         <tr  >
                          <td colspan="5"
                            class="px-6 text-right py-2 whitespace-no-wrap border-gray-200"
                          >
                            <div
                              class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900"
                            >
                            Total price: {{TotalPrice()}} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ************************************************************************************************-->
      </div>

      <div class="mt-6 pt-3 flex justify-center p-10" v-tooltip="{content:'Order Confirmed tu peu modifier dans la partie shipping',show:formData.status && formData.status.name && formData.status.name=='Confirmed'?true:false, trigger: 'manual'}">
        <button 
           
          class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300  loidingconfirm relative"
            @click="save"
            :class="loading||(formData.status && formData.status.name && formData.status.name=='Confirmed')?'noselect':''"><loading :active.sync="loading" :is-full-page="fullPage"></loading>
          Save
        </button>
      </div>
      <!-- ***********************************Pop up Affectation products to Order************************************************ -->

       <vue-modal-2 class="moukhtar"  name="myModal" :headerOptions="{title: 'Add Products'}" :noFooter="true" modalSize="lg" @on-close="closePopUp">
        <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
          <!-- Header -->
          <div class="flex w-full h-auto justify-center items-center">
            <div
              class="flex w-full h-auto py-3 justify-center items-center text-2xl font-bold"
            >
              <span
                class="w-screen md:w-full h-10 cursor-pointer border border-gray-500 rounded text-sm flex"
              >
                <input
                  type="search"
                  name="search"
                  v-model="searchText"
                  placeholder="Search"
                  class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none"
                />
                <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4"
                  >search</i
                >
              </span>
            </div>
          </div>
            <div v-if="products.length <= 0" class="py-2">
              <span
                class="w-full flex justify-center text-center py-20 border-b border-gray-500 text-base"
              >
                <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                  <span class="">No Products found </span>
                </p>
              </span>
            </div>
            <table class="table table-report sm:mt-2 table-p">
                <tr class="intro-x" v-for="(item, index) in resultSearchUsers"  :key="index" :value="item._id">
                  <td class="w-10 border-b border-t border-l border-gray-500"><input type="checkbox" class="form-checkbox order h-5 w-5 text-blue-500 border-gray-500" @change="addProductsToTemp(item)" v-model="item.check"/></td>
                  <td class="w-10 border-b border-t border-gray-500"><div class="flex"><div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden"><img :alt="item.name" :src="item.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"></div></div></td>
                  <td class="border-b border-t border-r border-gray-500"><div class="font-medium whitespace-nowrap">{{ item.name }}</div><div class="text-gray-600 text-xs whitespace-nowrap mt-0.5">{{ exceptDes(item.description) }}</div></td>
                 
                </tr>
            </table>  
        </div>

        <div class="modal-footer px-5 border0-t text-right">
          <button
            @click="closePopUp"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Cancel
          </button>
          <button
            @click="ConfirmOperation"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Confirm
          </button>
        </div>
      </vue-modal-2>
      <!-- ******************************************************** -->
    </div>
  </div>
</template>



<script>
import Table from '../../components/Table.vue';
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {
        source: "",
        zone: null,
        sourceLink: "",
        totalPrice:0,
        date: this.$moment(Date.now()).format('YYYY-MM-DD'),
        shippingdate:this.$moment(Date.now()).format('YYYY-MM-DD'),
        customer: {
          fullName: "",
          phone: "",
          //  shippingAddress: "",
          address: "",
        },
        warehouse:null,
        details: [],
        status: "",
        seller: null,
        warehouseParent:null
      },
      searchText: "",
      quantity: 0,
      status: [],

      products: [],
      show_modal: true,
      limit: 10,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      productselected: [],
      numberItemRepeated: 0,
      sellers: [],
      isDisabled: true,
      warehouses:[],
      options:this.$countries,
      loading:false,
      fullPage: false,
      checkWarehousingParent:[],
      zones:[]
    };
  },
  async mounted() {
    await this.getWarehouses();
    
    if (this.currentUser.type != "Seller") {
      if (this.currentUser.warehouses.length==1) {
        this.formData.warehouse=this.currentUser.warehouses[0];
        await this.getSellers(this.formData.warehouse._id||this.formData.warehouse);
      }
    } else {
      this.formData.seller = this.currentUser;
      if (this.formData.seller) this.isDisabled = false;
      if (this.currentUser.warehouses.length==1) this.formData.warehouse=this.currentUser.warehouses[0];
      //console.log(this.formData);
    }

    if(this.currentUser.warehouses.length==1 && this.currentUser.type != "Seller") {
        const resW = await this.$server.search("warehouses", { country: this.formData.warehouse.country,parent:true,limit:100}); 
        console.log('resW--------',resW)
        if(resW.content && resW.content.results) {
            this.checkWarehousingParent=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
        }else this.checkWarehousingParent=[];
    }

    await this.getStatus();
    await this.dataToEdit();
    this.dateMin();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    async CheckWarehouseParent(country){
      const resW = await this.$server.search("warehouses", { country: country,parent:true,limit:100}); 
      console.log('resW--------------',resW)
      if(resW.content && resW.content.results) this.checkWarehousingParent=resW.content.results;
      else this.checkWarehousingParent=[];
    },
    async getZones(warehouse) {
        const res = await this.$server.search("zones",{ limit: 10,warehouse:warehouse});
        if (res && res.content.results) this.zones = res.content.results;
        else this.zones = [];
    },
    serchZones: _.debounce(async function(name,type) {
       console.log('event______________',name)
       if(this.formData.warehouse){
          await this.$store.dispatch('wharhouse/searchUser',{type: 'zone',warhouse:this.formData.warehouse._id||this.formData.warehouse,search:name}).then((res) => {
            this.zones = res
          })
        }
   }, 500), 
    getUsersDebance: _.debounce(async function(name) {
      console.log('name----',name)
      if(this.formData.warehouse){
        await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.formData.warehouse._id||this.formData.warehouse,search:name}).then((res) => {
          this.sellers = res
        })
      }
   }, 500), 
    async getWarehouses(){
      this.warehouses = this.currentUser.warehouses;
        // const filter = {limit:1000};
        // if (this.currentUser.type === "Seller"){
        //     this.warehouses = this.currentUser.warehouses;
        // }else{
        //    const res = await this.$server.search("warehouses",filter);
        //     if (res.content.results) {
        //         this.warehouses = res.content.results;
        //     } else this.warehouses = [];
        // }
    }, 
    setSelectedWParent(){

    },
    async setSelectedW(warhouse){
         this.formData.details=this.checkWarehousingParent=[];
         this.formData.zone=this.formData.warehouseParent= null;
         if (warhouse) {
            this.formData.warehouse = warhouse;
           if (this.currentUser.type != "Seller"){
               this.formData.seller=null;
               await this.getSellers(warhouse._id||warhouse);

               const resW = await this.$server.search("warehouses", { country: warhouse.country,all:true,limit:100}); 
              console.log('resW--------',resW)
              if(resW.content && resW.content.results) {
                  this.checkWarehousingParent=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
              }else this.checkWarehousingParent=[];
           }  
          
         }else{this.formData.warehouse} 
    },
    dateMin(){ 
      // document.getElementById('date').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
    },
    exceptDes(text){
         if (text && text.length > 60) text = text.substring(0, 60) + "...";
      return text;
    },
    // changeSeller(seller) {
    //   console.log('seller_____________',seller  )
    //   if (this.formData.seller) {
    //     this.isDisabled = false;
    //     if (this.formData.details) {
    //       if (this.formData.details[0]) {
    //         if (
    //           this.formData.details[0].product.seller !=
    //           this.formData.seller._id
    //         ) {
    //           this.formData.details = [];
    //         }
    //       }
    //     }
    //   } else {
    //     this.isDisabled = true;
    //   }
    // },
    TotalPrice(){
      let Total=0;
        for (const element of this.formData.details) {
            Total+=element.unitPrice * element.quantity;
        }
        this.formData.totalPrice=Total;
        return Total;
     },
    async getUser() {
      const res = await this.$server.me("users");
      //console.log(res);
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },

    async getProducts() {
      if (this.formData.seller && this.formData.warehouse) {
          const filters = {
            seller: this.formData.seller._id||his.formData.seller,
            warehouse:this.formData.warehouse._id||this.formData.warehouse,
            limit:3000
          };

        const res = await this.$server.search("products", filters);
        if(res && res.content) {
            this.products = res.content;
            for (let i in this.products) {
              this.products[i].quantity = this.products[i].details[0].quantity.inStock;
              this.products[i].price = this.products[i].details[0].price;
              this.products[i].seller = this.products[i].seller;
            }
        }else this.products = [];
      }else  alert("You must select a seller", "warning");
    },

    async getStatus() {
      const res = await this.$server.search("status");
      if (res.content.results) this.status = res.content.results;
      else this.status = [];
    },
     SumTotalPrice(data) {
       let total=0;
        for (let i in data) {
          total += data[i].quantity * data[i].unitPrice;
        }
        return total;
     },
    async save() {
      if (this.formData._id) {
        if (!this.checkData()) {
          alert(`you must fill all the fields !! `, "warning");
          return false;
        }
        this.loading=true;
        this.formData.totalPrice=this.SumTotalPrice(this.formData.details);
        this.formData.customer.phone= this.formData.customer.phone.replace(/[^|\d]/g, ''); 
        if(this.checkDetails()) {this.loading=false;return false;}
        const data = await this.$server.update("orders", this.formData);
        this.loading=false;
        if (data && data._id) {
           alert("Order updated", "success");
          //  const shippingdata = await this.$server.get("shippings", {order: data._id,});
          //  if(shippingdata.content){
          //    shippingdata.content.orderObjet=this.formData;
          //    await this.$server.update("shippings", shippingdata.content);
          //  }
          //  console.log('shippdata------',shippingdata)
          //await this.dataToEdit();
        }else {alert(data, "warning"); await this.dataToEdit();}
      } else {
        if (this.checkData()) {
          //this.formData.seller = this.currentUser._id;

         // for (let i = 0; i < this.formData.details.length; i++) {
            //this.formData.details[i].unitPrice = this.formData.details[i].product.price;
            //this.formData.details[i].category=this.formData.details[i].product.category
          //}

          if(this.checkWarehousingParent.length>0 && this.formData.warehouse && !this.formData.warehouseParent && this.currentUser.type != "Seller"){
            this.loading=false;
            alert("Zone required !", "warning");
            return false;
          }
          this.loading=true;
          this.formData.totalPrice=this.SumTotalPrice(this.formData.details);
          this.formData.customer.phone= this.formData.customer.phone.replace(/[^|\d]/g, ''); 
         // this.formData.createdAt=new Date();
        //  if(this.currentUser.type != "Seller"){
        //     for (let index = 0; index < this.formData.details.length; index++) {
        //           const orderLine = this.formData.details[index];
        //           const product = await this.$server.get("products",{  _id: orderLine.product._id } )
        //           const dataWhrahouse=this.$f.getElementInArray( product.content.details,this.formData.warehouse);
        //           if (dataWhrahouse.outOfStock || orderLine.quantity >=dataWhrahouse.quantity.inStock) {
        //               this.loading=false;
        //               return  alert(`Quantité en stock insuffisante pour ce produit !! `, "warning");
        //               break;
        //           }
        //       }
        //   }
          //console.log('formadata seller ------',this.formData)
          if(this.formData.seller.status != 'active'){
              alert("cette user n'est pas active contacter shipsen pour l'activer merci", "warning");
               this.loading=false;
              return false
          }
          if(this.checkDetails()) {this.loading=false;return false;}
          this.formData.CreateMnaualy=true;
          this.formData.checkWarehousingParent=this.checkWarehousingParent;
          this.formData.country=this.idWharhouse.country;
          const data = await this.$server.create("orders", this.formData);
          this.loading=false;
          if (data && data._id) {
            this.formData = {
              customer: {},
              details: [],
              zone: null,
              warehouseParent:null
            };
            this.formData.checkWarehousingParent=this.checkWarehousingParent=[];
             if (this.currentUser.type == "Seller"){
               this.formData.seller = this.currentUser;
               if (this.formData.seller) this.isDisabled = false;
            }
             if (this.currentUser.warehouses.length==1) this.formData.warehouse=this.currentUser.warehouses[0];
            alert("Order created !", "success");
          }else  alert(data, "warning");
        } else {
          alert(`you must fill all the fields !! `, "warning");
        }
      }
    },
    checkDetails(){
      let exitError=false;
      for (let index = 0; index < this.formData.details.length; index++) {
          const orderLine = this.formData.details[index];
          console.log('orderLine price-----',orderLine.unitPrice)
          if (!orderLine.unitPrice || (orderLine.unitPrice && orderLine.unitPrice=="0")) {
            console.log('Not exit price-----')
              exitError=true;
              alert(`Unit price pour ce produit est required ${orderLine.product.name}`, "warning");
              break;
          }
      }
      if(exitError) return true;
      else return false;
   },
    checkData() {
      if (
       // this.formData.source &&
        //this.formData.sourceLink &&
      //  this.formData.date &&
        this.formData.totalPrice &&
        this.formData.totalPrice>0 &&
        this.formData.warehouse &&
        this.formData.details.length > 0 &&
        this.formData.customer.address &&
        this.formData.customer.phone &&
        this.formData.customer
      )
      return true;
      else return false;
    },

    removeProduct(data, index) {
      this.$confirm("Are you sure you want to delete this product?").then(
        async (res) => {
           var index = this.formData.details.findIndex(function(o){return o.product._id === data.product._id;})
           if (index !== -1) this.formData.details.splice(index, 1);
          data.product.check = false;
          alert(`Product deleted !`, "success");
        }
      );
    },

    addProductsToTemp(data) {
      if (data.check) {
        console.log("data",data)
        const detail = {
          product: data,
          unitPrice: data.price,
          quantity: 1,
        };
        if (data.category) {
          if (data.category._id) {
            detail.category = data.category._id;
          } else {
          }
        }

        console.log("HIII JE SUIS DETAIL", detail);
        let found = 0;
        for (let i = 0; i < this.formData.details.length; i++) {
          if (this.formData.details[i].product._id == data._id) {
            found = found + 1;
            this.numberItemRepeated = this.numberItemRepeated + 1;
          }
        }
        if (found >= 1) {
        } else {
          this.productselected.push(detail);
        }
      } else {
        let pos = this.productselected
          .map(function (e) {
            return e.product._id;
          })
          .indexOf(data._id);
        this.productselected.splice(pos, 1);
      }
    },

    addQuantity(index) {
      this.formData.details[index].quantity++;
    },
    removeQuantity(index) {
      if (this.formData.details[index].quantity <= 1) {
      } else {
        this.formData.details[index].quantity--;
      }
    },

    async OpenPopUp() {
      if(!this.formData.warehouse){
        alert('Please select a country', "warning");
        return false;
      } 
      if (this.formData.seller) {
        await this.getProducts({});
        if (this.products.length > 0) {
            this.$vm2.open("myModal");
        } else {
          if (this.currentUser.type != "Seller")
            alert(`There are no products for the selected seller`, "warning");
          else alert(`You haven't added any product yet`, "warning");
          //console.log("HIIIIII JE SUIS LA");
        }
      }
    },
    ConfirmOperation() {
      let fount = 0;
      for (let i = 0; i < this.productselected.length; i++) {
        this.formData.details.push(this.productselected[i]);
      }
      
      this.productselected = [];
      if (this.numberItemRepeated > 0) {
        alert(`There are many products already added!`, "success");
      }
      this.numberItemRepeated = 0;
       this.$vm2.close("myModal");
    },
    closePopUp() {
      //console.log("close");
      this.$vm2.close("myModal");
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("orders", {
          id: this.$route.params.id,
        });
        this.formData = editData.content;
         if (this.formData.seller) this.isDisabled = false;
        //console.log(this.formData);
        if(this.formData.date) this.formData.date =this.$moment(this.formData.date).format('yyyy-MM-DDTHH:mm');
        if(this.formData.details[0].warehouseParent) {
          this.formData.warehouseParent={_id:this.formData.details[0].warehouseParent,name:this.formData.details[0].warehouseParentName};
          this.checkWarehousingParent=[{_id:this.formData.details[0].warehouseParent,name:this.formData.details[0].warehouseParentName}];
        }
      }
    },
    async getSellers(warehouse) {
      const filter = {
        type: "Seller",
        warehouses:warehouse,
        limit:10
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    },

    changeSeller(seller) {
      console.log("HIIIIIIII", seller);
      if (this.currentUser.type != "Seller" && seller) {
        this.isDisabled = false;
        if (this.formData.details) {
          if (this.formData.details[0]) {
            if (
              this.formData.details[0].product.seller !=
              seller._id
            ) {
              this.formData.details = [];
            }
          }
        }
      } else {
        this.isDisabled = true;
      }
    },
  },

  computed: {
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter((product) => {
          var regex = new RegExp(this.searchText, "i");

          return regex.test(product.name);
        });
      } else {
        return this.products;
      }
    },
  },

  /************************************* Pagination **************************************************/
};
</script>

<style scoped>

.toggle__dot {
  transition: all 0.3s ease-in-out;
}
input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #68d391;
}
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.vs__dropdown-toggle {
    border: none;
} 
.form-checkbox.order{
  border-color: inherit;
}
</style>
